<template lang="pug">
CardMinimal.revenue-report
  .swish-payout(v-if="accountCountry.toLowerCase() === 'se'")
    strong Swish:&nbsp;
    | Payouts are made 14 days after the end of the month
  template(v-if="fetchingPayouts")
    div.loading
      i.mdi.mdi-loading.mdi-spin
  template(v-else)
    template(v-if="!data")
      div.no-reports.p-a-4
        p {{ $t('commerce.sorry_no_payouts') }}
    div(v-else)
      table
        tr
          th.amount-col-header {{ $t('ticket.amount')}}
          th.status-col-header
          th.bank-col-header Bank
          th.date-col-header {{ $t('ticket.date') }}
        template(v-for="payout in data")
          tr(:key="payout.id", @click="onClick(payout.id)")
            td.amount {{ payout.amount/100 | formatNumbers}} {{ payout.currency | fomatCurrency }}
            td.status
              Tag(:text="$t(`commerce.${payout.status}`)", :class="{'capitalize': true, 'gray': payout.status === 'in_transit' || payout.status === 'pending', 'mr-1': true}")
              Tag(:text="$t(`commerce.${payout.type}`)", :class="{'capitalize': true, 'purple': true}")
            td
              span {{ payout.bank_name }}
              span.last4 •••• {{ payout.bank_last4 }}
            td.date {{ payout.arrival_date | formatDate }}
</template>

<script>
import moment from 'moment';
import Tag from '@/components/tag.vue';

export default {
  computed: {
    accountCountry() { return this.$store.getters['AccountManager/accountCountry']; },
  },
  data() {
    return {
      data: null,
      fetchingPayouts: true,
    };
  },
  mounted() {
    this.fetchPayouts();
  },
  components: {
    Tag,
  },
  methods: {
    async fetchPayouts() {
      this.fetchingPayouts = true;
      const payouts = await ovpFetch('/payouts').catch(() => false);
      this.fetchingPayouts = false;
      if (!payouts || Object.keys(payouts.data).length <= 0) {
        this.data = null;
        return;
      }
      this.data = payouts.data;
    },
    onClick(id) {
      this.$router.push({ path: `/payouts/${id}` });
    },
  },
  filters: {
    formatNumbers(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    formatDate(value) {
      return moment(value).format('MMM D');
    },
    fomatCurrency(value) {
      return value.toUpperCase();
    },
  },
};
</script>

<style lang="sass" scoped>

@import '../variables.sass'

.swish-payout
  padding: 13px 20px 10px
  background-color: #35ACDC
  color: #FFFFFF
  border-bottom: 1px solid #eeeeee
  font-size: .85rem
table
  border-spacing: 0
  display: block
  overflow-x: auto
  position: relative
  white-space: nowrap
  width: 100%
  -webkit-overflow-scrolling: touch
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Inter, "Helvetica Neue", Ubuntu, sans-serif
  & > *
    transform: translate3d(0, 0, 0)
  th
    color: $mutedColor
    font-size: 12px
    padding: 16px 10px 8px 10px
    text-align: left
    &.amount-col-header
      text-align: right
    &.date-col-header
      text-align: right
    &.bank-col-header
      width: 100%
  tr
    td
      border-top: 1px solid #eee
      padding: 10px
      &.status-col
        text-transform: uppercase
        text-align: center
      &.amount
        font-weight: 500
        text-align: right
      &.date
        text-transform: capitalize
        text-align: right
      span.last4
        padding-left: 10px
    &:hover, &.open
      td:not(.transactionInfo)
        cursor: pointer
        background-color: rgba($mutedColor, .05)
</style>
